// src/pages/Proposals/FileDialog/forms/common/PISelect.js
import React from "react";
import PropTypes from "prop-types";
import EntitySelect from "../common/EntitySelect";

function PISelect({ value, onChange, label = "Principal Investigator", sx }) {
  return (
    <EntitySelect
      value={value}
      onChange={onChange}
      endpoint="/researcher/?pi_only=true"
      label={label}
      getOptionLabel={(opt) => opt.display_name || `${opt.name} ${opt.surname}`}
      searchParam="search"
      sx={sx}
    />
  );
}
PISelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  sx: PropTypes.object,
};
PISelect.defaultProps = {
  value: null,
  label: "Principal Investigator",
  sx: {},
};

export default React.memo(PISelect);
